// libs
import styled from "styled-components";
import { motion, Variants } from "framer-motion";
// components
import { Box } from "../Box";
import ATInnerSlide from "./ATInnerSlide";
// other
import { fill } from "../../styles/utils";
import { InteractiveInnerSlide } from "../../models/client";

interface ATInnerSlidesProps {
  innerSlides: InteractiveInnerSlide[];
  innerSlideIndex: number;
  direction: number;
  visualInnerSlides: any;
}

const MotionFill = styled(motion(Box))`
  ${fill()}
`;

const tempVars: Variants = {
  hiddenFront: { opacity: 0, zIndex: 3, pointerEvents: "none" },
  front: { opacity: 1, zIndex: 2, pointerEvents: "all" },
  second: { opacity: 1, zIndex: 1, pointerEvents: "none" },
  third: { opacity: 1, zIndex: 0, pointerEvents: "none" },
  hiddenBack: { opacity: 0, zIndex: 0, pointerEvents: "none" },
};

const getVarSingle = (i: number) => {
  switch (i) {
    case 0:
      return "front";
  }
};
const getVar = (i: number) => {
  switch (i) {
    case -1:
      return "hiddenBack";
    case 0:
      return "hiddenFront";
    case 1:
      return "front";
    case 2:
      return "second";
    case 3:
      return "hiddenBack";
    case 4:
      return "hiddenBack";
    case 5:
      return "hiddenBack";
  }
};

const getVarThreeOrMore = (i: number) => {
  switch (i) {
    case -2:
      return "hiddenBack";
    case -1:
      return "hiddenBack";
    case 0:
      return "hiddenFront";
    case 1:
      return "front";
    case 2:
      return "second";
    case 3:
      return "third";
    case 4:
      return "hiddenBack";
    case 5:
      return "hiddenBack";
    case 6:
      return "hiddenBack";
  }
};

const getVarFn = (slidesLength: number) => {
  if (slidesLength === 1) {
    return getVarSingle;
  }
  if (slidesLength === 2) {
    return getVar;
  }
  return getVarThreeOrMore;
};

function ATInnerSlides({
  innerSlides,
  innerSlideIndex,
  visualInnerSlides,
}: ATInnerSlidesProps) {
  if (!visualInnerSlides.length) {
    return <div>loading...</div>;
  }

  return (
    <Box
      position="relative"
      ml={[0, null, null, 5]}
      pt={["calc(100% + 2em)", null, null, "100%"]}
      mb={[4, null, null, 0]}
    >
      {visualInnerSlides.map((slide: any, i: number) => (
        <MotionFill
          id={slide.key}
          key={slide.key}
          initial={false}
          animate={getVarFn(innerSlides.length)(i - innerSlideIndex)}
          variants={tempVars}
          transition={{ duration: 0.5 }}
        >
          <ATInnerSlide innerSlide={slide}></ATInnerSlide>
        </MotionFill>
      ))}
    </Box>
  );
}

export default ATInnerSlides;
